"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { sendEmail } from "@/utils/send-email";
import { sendToDiscord_Contact } from "./ContactToDiscord";
import confetti from "canvas-confetti";
import { useToast } from "@/hooks/use-toast";
import posthog from "posthog-js";

const nameSchema = z.string().trim().min(1, { message: "Name is required" });
const emailSchema = z
  .string()
  .trim()
  .min(1, { message: "Email is required so I can contact you back" })
  .email({ message: "Invalid email address" });
const textSchema = z.string().trim().min(1, { message: "Message is required" });
//.max(500, { message: "Message cannot exceed 500 characters" });

export const formSchema = z.object({
  name: nameSchema,
  email: emailSchema,
  text: textSchema,
});

const confettiCannon = () => {
  const end = Date.now() + 3 * 1000; // 3 seconds
  const colors = ["#a786ff", "#fd8bbc", "#eca184", "#f8deb1"];

  const frame = () => {
    if (Date.now() > end) return;

    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      startVelocity: 60,
      origin: { x: 0, y: 0.5 },
      colors: colors,
    });
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      startVelocity: 60,
      origin: { x: 1, y: 0.5 },
      colors: colors,
    });

    requestAnimationFrame(frame);
  };

  frame();
};
const closeDialog = () => {
  // easiest way to close the shadcn dialog, but hacky af
  const escapeEvent = new KeyboardEvent("keydown", {
    key: "Escape",
    code: "Escape",
    keyCode: 27,
    which: 27,
    bubbles: true,
  });
  document.dispatchEvent(escapeEvent);
};
const triggerToast = (toast: any) => {
  // inform user that form was succesfuly sumbitted and i will reply soon as possible
  toast({
    title: "Message sent!",
    description:
      "Thanks for reaching out! I’ll get back to you as soon as possible.",
  });
};
export function ContactForm() {
  const { toast } = useToast();

  // 1. Define your form.
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
    },
  });

  // 2. Define a submit handler.
  function onSubmit(values: z.infer<typeof formSchema>) {
    //sendEmail(values);
    sendToDiscord_Contact(values);
    confettiCannon();
    closeDialog();
    triggerToast(toast);

    posthog.capture("contact_form_submitted", {
      name: values.name,
      email: values.email,
    });
    posthog.identify(
      values.email, // ID from AUTH
      { name: values.name },
      { email: values.email }
      //{ refearral_code: "contact_form" }
    );
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-2"
      >
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              {/* <FormLabel>Full Name</FormLabel> */}
              <FormControl>
                <Input type="text" placeholder="Full Name" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              {/* <FormLabel>Email</FormLabel> */}
              <FormControl>
                <Input type="email" placeholder="Email" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="text"
          render={({ field }) => (
            <FormItem>
              {/* <FormLabel>Email</FormLabel> */}
              <FormControl>
                <Textarea rows={4} placeholder="Message" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="submit">Submit</Button>
      </form>
    </Form>
  );
}
